import React from 'react';
import { RouteComponentProps } from '@reach/router';
import { Navbar } from '../../components/Navbar';
import { Wrapper } from '../../components/Wrapper';
import { getLocationPath, getPath, getStageColors } from '../../utils';
import { SecondaryNavWrapper } from '../../components/Styled';
import { WelcomeModal } from '../Login/WelcomeModal';
import { NAV_LIST } from '../../constants/navigation';

export const SecondaryNav: React.FC<RouteComponentProps> = (props): JSX.Element => {
  const { location } = props;

  const showNav = location && getLocationPath(location.pathname).length < 3;
  const path = props.path ? props.path.replace(/\//g, '') : '';
  const { gradient: gradientColor } = getStageColors(getPath(location));

  return (
    <Wrapper>
      {localStorage.getItem('firstTime') === 'true' ? <WelcomeModal /> : ''}
      <Wrapper color={gradientColor}>
        <div>
          {showNav && (
            <SecondaryNavWrapper data-testid="secondary-nav">
              <Navbar
                isSecondary={true}
                current={getPath(location)}
                ariaLabel="secondary navigation"
                navLinks={NAV_LIST[path]}
              />
            </SecondaryNavWrapper>
          )}
        </div>
      </Wrapper>
      {props.children}
    </Wrapper>
  );
};
